/* eslint-disable */
import {extendDecorator} from '@/js/common/Domain/Service/mixins/decorators';
import gaAsync from '@/js/common/Domain/Service/gaAsync';
import PopupWrapperView from '@/js/desktop/components/popup/PopupWrapper';

import ReviewFormModel from './ReviewFormModel';
import template from './template.html';
import CheckBoxInputCommon from '@ve/components/inputs/common/CheckBoxInputCommon.vue';
import { mountCheckboxes, validateRequiredCheckboxes } from '@/js/common/Service/checkboxValidation';
import { getCheckboxConfigs } from '@/js/common/Service/checkboxValidation';

import './reviewForm.scss';

@extendDecorator({
    el: template(),
    events: {
        'click section .stars > *': 'selectRating',
        'click .sendComment': 'submitData',
    },
    bindings: {
        '.js-epoxy-service-value': 'text:service',
        '.js-epoxy-location-value': 'text:location',
        '.js-epoxy-meals-value': 'text:meals',
        'input[name=service]': 'value:service',
        'input[name=location]': 'value:location',
        'input[name=meals]': 'value:meals',
        '.js-epoxy-rating-text': 'text:ratingText',
        '.js-block-bg': 'attr:{class:ratingClass}',
    },
})
export default class ReviewForm extends Backbone.Epoxy.View {
    initialize() {
        this.model = new ReviewFormModel();
        this.model.set({
            agreeUserAgreement: true,
            agreePersonalData: true,
					  agreeDisseminationAndPersonalData: true,
            isReviewSent: false,
            advertisingConsentLocked: false,
        });

        this.checkboxIdPrefix = 'review-checkbox-';

        this.reviewDg = new PopupWrapperView({
            el: this.$el,
            dialogClass: 'leaveCommentFormDG',
        });
        this.initValidation();

        this.observeCheckboxesAndEmailInput();
    }

    openReviewForm() {
        this.reviewDg.show();
    }

    collectData() {
        const data = {};
        const serealizedData = $('form.addReviewForm').serializeArray();

        for (let i = 0; i < serealizedData.length; i++) {
            data[serealizedData[i].name] = serealizedData[i].value;
        }

        if (!$('form.addReviewForm .userInfo input').eq(0).is(':visible')) {
            delete (data.name);
            delete (data.email);
            delete (data.comment);
        }

        return data;
    }

    submitData(e) {
        const $form = $('form.addReviewForm');

        e.preventDefault();
        e.stopPropagation();

        $form.find('span.err').removeClass('err');
        $form.find('[name="meals"]').valid();
        $form.find('[name="location"]').valid();
        $form.find('[name="service"]').valid();
        $form.valid();

        if (!validateRequiredCheckboxes(this.model, ['agreeUserAgreement', 'agreeDisseminationAndPersonalData'], $form[0])) {
            return;
        }

        if (!$(e.target).hasClass('disabled') && $form.find('[name="meals"], [name="location"], [name="service"]').valid() && $form.valid()) {
            const data = this.collectData();
            $form.find('.sendComment').addClass('disabled');
            this.sendReview(data)
                .done((response) => {
                    $form.find('.sendComment').removeClass('disabled');
                    if (response.success === true) {
                        gaAsync(() => {
                            ga('send', 'event', 'Hotel_Card', 'Review', document.location.pathname, {nonInteraction: 1});
                        });
                        this.model.set('isReviewSent', true);
                        $form.hide();
                        $form.next().show();
                    } else if (typeof console !== 'undefined' && typeof console.log === 'function') {
                        console.log('something wrong!!');
                        console.log(response.message);
                    }
                });
        }
    }

    sendReview(data) {
        return $.ajax({
            url: '/feedback/add',
            data: {
                mealRate: data.meals,
                locationRate: data.location,
                serviceRate: data.service,
                user: data.name,
                email: data.email,
                text: data.comment,
                hotel: window.appConfig.hotelInfo.id,
                agreedWithPolicy: false,
            },
            dataType: 'json',
            type: 'POST',
        });
    }

    selectRating(e) {
        const $element = $(e.target);
        const rating = $element.attr('rel');
        const fieldName = $element.parent().attr('class', 'stars').addClass(`r${rating}`)
            .parent()
            .find('input')
            .attr('name');

        this.model.set(fieldName, +rating);
    }

    initValidation() {
        const $form = $('form.addReviewForm', this.reviewDg.$el);

        $form.validate({
            ignore: '',
            errorClass: 'err',
            rules: {
                meals: {
                    required: true,
                },
                location: {
                    required: true,
                },
                service: {
                    required: true,
                },
                name: {
                    required: true,
                },
                email: {
                    required: true,
                    email: true,
                    remote: '/validate/emailValidate',
                },
            },
            messages: {
                meals: {
                    required: '',
                },
                location: {
                    required: '',
                },
                service: {
                    required: '',
                },
                name: {
                    required: '',
                },
                email: {
                    required: '',
                    email: '',
                },
            },
            errorPlacement(error, element) {
                $(element).parents('label, section').find('.commentFormLabel').addClass('err');
            },
        });
    }

    observeCheckboxesAndEmailInput() {
        const checkboxesReady = this.mountCheckboxesIfReady();
        if (checkboxesReady) return;

        const observer = new MutationObserver(() => {
            const checkboxesReadyNow = this.mountCheckboxesIfReady();
            if (checkboxesReadyNow) observer.disconnect();
        });
        observer.observe(this.$el[0], { childList: true, subtree: true });
    }

    mountCheckboxesIfReady() {
        const $form = this.$el.find('form.addReviewForm');
        if ($form.length) {
            const configs = getCheckboxConfigs(this.model, this.checkboxIdPrefix);
            mountCheckboxes(configs, this.model, CheckBoxInputCommon);
            return true;
        }
        return false;
    }

}